import classNames from "classnames/bind";
import * as React from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  color?: "#fd6a65" | "black";
  size?: 40 | 32;
  withBackground?: boolean;
}

export const SyllabusIcon: React.FC<React.PropsWithChildren<Props>> = ({
  color = "#fd6a65",
  size = 40,
  withBackground = false,
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <g fill={color}>
            <path
              d="M17.95 6.75h-4.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C8.75 9.03 8.75 9.87 8.75 11.55v8.2h14v-8.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311c-.642-.327-1.482-.327-3.162-.327Z"
              fillRule="nonzero"
              opacity=".12"
            />
            <path d="M13.518 6h4.464c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2V21.58c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.074A2.751 2.751 0 0 1 22 25.2c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-8.33A3.25 3.25 0 0 1 8 22.25V11.518c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365C12.05 6 12.706 6 13.519 6ZM9.5 22.25c0 .967.784 1.75 1.75 1.75h8.3c.572 0 .957 0 1.253-.025.287-.023.424-.065.515-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253V20.5H11.25a1.75 1.75 0 0 0-1.75 1.75Zm0-2.74v-7.96c0-.852 0-1.447.038-1.91.037-.453.107-.714.207-.911a2.25 2.25 0 0 1 .984-.984c.197-.1.458-.17.912-.207.462-.037 1.057-.038 1.909-.038h4.4c.853 0 1.447 0 1.91.038.453.037.714.107.912.207.423.216.767.56.983.984.1.197.17.458.207.912.037.462.038 1.057.038 1.909V19H11.25c-.644 0-1.245.188-1.75.51Zm2.5-8.76a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z" />
          </g>
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
